import { compactTeamName, fullTeamName } from './printLabels';
import type { CompetitionGroup } from '../../../types';

/**
 * One A4 page per group: a hand-tally standings table (blank cells) plus the
 * full round-robin with wide blank score boxes and a dashed "saldo" box at each
 * end of every match. Handed to the group's players to record by pen.
 */
export function GroupSheet({
  tournamentName,
  group,
}: {
  tournamentName: string;
  group: CompetitionGroup;
}) {
  const teamCount = group.teams.length;
  const matchCount = group.matches.length;

  return (
    <section className="sheet">
      <header className="page-head">
        <div className="title">
          <small>{tournamentName} · Beach Tennis</small>
          Grupo {group.groupNumber}
        </div>
        <div className="meta">
          <div>
            Formato: <b>set único · até 6 games</b>
          </div>
          <div>
            <b>Tiebreak</b> de 7 pontos em 6-6
          </div>
          <div style={{ marginTop: 4 }}>
            Quadra: <span className="long-line" />
          </div>
        </div>
      </header>

      <table className="standings">
        <colgroup>
          <col className="c-pos" />
          <col className="c-dupla" />
          <col className="c-stat" />
          <col className="c-stat" />
          <col className="c-stat" />
        </colgroup>
        <thead>
          <tr>
            <th>
              #<span className="sub">posição</span>
            </th>
            <th style={{ textAlign: 'left', paddingLeft: 12 }}>Dupla</th>
            <th>
              V<span className="sub">vitórias</span>
            </th>
            <th>
              D<span className="sub">derrotas</span>
            </th>
            <th>
              Saldo<span className="sub">de games</span>
            </th>
          </tr>
        </thead>
        <tbody>
          {group.teams.map((team) => (
            <tr key={team.id}>
              <td />
              <td className="dupla">{fullTeamName(team)}</td>
              <td />
              <td />
              <td />
            </tr>
          ))}
        </tbody>
      </table>

      <div className="section-label">
        Jogos do grupo — todos contra todos
        <span className="round-sub" style={{ fontWeight: 700, float: 'right', border: 0 }}>
          {teamCount} duplas · {matchCount} jogos
        </span>
      </div>
      <p className="hint">
        Caixas tracejadas nas pontas: anote o saldo de games de cada dupla na partida (a favor − contra).
      </p>

      <div className="matches">
        {group.matches.map((match, i) => (
          <div className="match-row" key={match.id}>
            <div className="jogo">Jogo {i + 1}</div>
            <div className="saldo-cell">
              <span className="saldo-cap">saldo</span>
              <span className="box saldo" />
            </div>
            <span className="name r">{compactTeamName(match.team1)}</span>
            <span className="box score" />
            <span className="vs">×</span>
            <span className="box score" />
            <span className="name l">{compactTeamName(match.team2)}</span>
            <div className="saldo-cell">
              <span className="saldo-cap">saldo</span>
              <span className="box saldo" />
            </div>
          </div>
        ))}
      </div>

      <div className="foot-note">
        <span>
          Vitória = +1 V &nbsp;·&nbsp; Derrota = +1 D &nbsp;·&nbsp; Saldo = games a favor − games contra
        </span>
        <span>{tournamentName}</span>
      </div>
    </section>
  );
}
